<template>
  <modal
    name="enrollInLoyalty"
    modal-style="compact"
    :display-header-title="false"
    @closed="closedHandler"
  >
    <div
      v-if="wasEnrolled"
      class="cf-flex cf-flex--column cf-flex--align-center cf-flex--gap-16 cf-padding-y-16 animation-slide-left"
    >
      <img
        v-if="content.LoyaltyEnrollmentSuccess.metadata.imageUrl"
        class="cf-image cf-image--logo"
        :alt="merchant.name"
        :src="content.LoyaltyEnrollmentSuccess.metadata.imageUrl"
        onerror="this.src='/images/image-not-found.png';"
      >

      <h2 class="cf-title cf-title--2">
        {{ content.LoyaltyEnrollmentSuccess.title }}
      </h2>

      <p class="cf-subtitle cf-subtitle--2">
        {{ content.LoyaltyEnrollmentSuccess.description }}
      </p>

      <button
        class="cf-button cf-button--primary cf-button--lg cf-button--fill"
        type="button"
        @click="$closeModal('enrollInLoyalty')"
      >
        Continue
      </button>
    </div>

    <div
      v-else-if="shouldEnrollUser"
      class="cf-padding-bottom-16"
    >
      <cf-collect-account-info
        :class="{'animation-slide-left': !shouldSkipFirstAnimation }"
        mode="enrollInLoyalty"
        @success="enrollSuccessHandler"
      >
        <template #header>
          <sign-up-header />
        </template>
      </cf-collect-account-info>
    </div>

    <div
      v-else
      class="cf-flex cf-flex--column cf-flex--align-center cf-flex--gap-16 cf-padding-y-16"
    >
      <img
        v-if="content.LoyaltyEnrollment.metadata.imageUrl"
        class="cf-image cf-image--logo"
        :alt="merchant.name"
        :src="content.LoyaltyEnrollment.metadata.imageUrl"
        onerror="this.src='/images/image-not-found.png';"
      >

      <h2 class="cf-title cf-title--2">
        {{ content.LoyaltyEnrollment.title }}
      </h2>

      <p class="cf-subtitle cf-subtitle--2">
        {{ content.LoyaltyEnrollment.description }}
      </p>

      <button
        class="cf-button cf-button--primary cf-button--lg cf-button--fill"
        type="button"
        @click="enroll"
      >
        {{ content.LoyaltyEnrollment.metadata.buttonCta }}
      </button>
    </div>
  </modal>
</template>


<script>
  import events from '@/services/events';

  import { mapGetters } from 'vuex';

  import CfCollectAccountInfo from '@/view/components/globals/cf-collect-account-info/index.vue';

  import SignUpHeader from '@/view/components/modals/sign-up-modal/sign-up-header/index.vue';


  export default {
    name: 'EnrollInLoyalty',

    components: {
      CfCollectAccountInfo,
      SignUpHeader
    },

    data() {
      return {
        shouldEnrollUser: false,
        shouldSkipFirstAnimation: false,
        wasEnrolled: false
      };
    },

    computed: {
      ...mapGetters('content', ['content']),
      ...mapGetters('merchant', ['loyaltyOptions', 'merchant']),
      ...mapGetters('offers', ['loyalty']),
      ...mapGetters('session', ['currentUser', 'session'])
    },

    created() {
      this.createdHandler();
    },

    unmounted() {
      this.destroyedHandler();
    },

    methods: {
      createdHandler() {
        events.on('enroll-in-loyalty:open', this.open);
        events.on('signed-in', this.open);
      },

      destroyedHandler() {
        events.off('enroll-in-loyalty:open', this.open);
        events.off('signed-in', this.open);
      },

      closedHandler() {
        this.shouldEnrollUser = false;
        this.shouldSkipFirstAnimation = false;
        this.wasEnrolled = false;
      },

      enroll() {
        this.shouldEnrollUser = true;
      },

      enrollSuccessHandler() {
        this.wasEnrolled = true;
      },

      open(options = {}) {
        if (
          !this.loyaltyOptions.loyaltyEnrollmentEnabled
          || this.loyalty.isEnrolled
          || (this.session.hasBeenPromptedToEnrollInLoyalty && !options.forceOpen)
        ) {
          return;
        }

        if (options.skipInitialContent) {
          this.shouldEnrollUser = true;
          this.shouldSkipFirstAnimation = true;
        }

        if (this.currentUser.accountId) {
          this.$openModal('enrollInLoyalty');
          this.$store.dispatch('session/updateHasBeenPromptedToEnrollInLoyalty', true);
        }

        else if (options.forceOpen) {
          this.$openModal('createAccount');
        }
      }
    }
  };
</script>
